<template>
  <div>
    <VueUeditorWrap
      v-model="content"
      :config="myConfig"
      @beforeInit="addCustomButtom"
    ></VueUeditorWrap>

    <el-dialog
      title="图片上传"
      :visible.sync="dialogVisible"
      width="500px"
      :lock-scroll="true"
      :close-on-click-modal="false"
    >
      <div class="image-upload-panel">
        <div class="choose-item">
          <p
            v-for="item in selectTab"
            :key="item.id"
            @click="chooseUpload(item.id)"
            :class="{ selected: selectedUpload == item.id }"
          >
            {{ item.name }}
          </p>
        </div>

        <UploadImage
          :img="image"
          :width="220"
          :height="150"
          @getUploadImage="getUploadImage"
          class="form-content-img"
        ></UploadImage>
        <p v-if="selectedUpload == 2">视频封面图</p>
        <video
          controls
          :src="video"
          class="video"
          v-if="video && selectedUpload == 2"
        ></video>

        <UploadVideo
          v-if="selectedUpload == 2"
          class="upload-video"
          @getUploadVideo="getUploadVideo"
        ></UploadVideo>

        <div>
          <span style="fontweight: bold">宽度:</span>
          <div style="display: inline-block; width: 180px; margin-top: 5px">
            <el-input
              v-model="size.width"
              size="small"
              placeholder="输入宽度,如:100,50%"
            ></el-input>
          </div>
        </div>
        <div>
          <span style="fontweight: bold">高度:</span>
          <div style="display: inline-block; width: 180px; margin-top: 5px">
            <el-input
              v-model="size.height"
              size="small"
              placeholder="输入高度,如:100,50%"
            ></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            () => {
              this.dialogVisible = false;
            }
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
let editorHandler;
import VueUeditorWrap from "vue-ueditor-wrap";
import UploadImage from "./uploadImage.vue";
import UploadVideo from "./uploadVideo.vue";
import { textStopWord_Api } from "../../apis/tools.api";

export default {
  components: {
    VueUeditorWrap,
    UploadVideo,
    UploadImage,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      stop_words: [],
      checked: false,
      selectedUpload: 1,
      selectTab: [
        { name: "图片", id: 1 },
        { name: "视频", id: 2 },
      ],
      video: null,
      image: null,
      size: {
        width: null,
        height: null,
      },
      dialogVisible: false,
      editorHandler: null,
      content: this.value,
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 540,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！部署在国外的服务器，如果无法访问，请自备梯子）
        serverUrl: "",
        allowDivTransToP: false,
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/static/UEditor/",
      },
    };
  },
  mounted() {},
  methods: {
    chooseUpload(id) {
      this.selectedUpload = id;
    },
    getUploadVideo(data) {
      this.video = data;
    },
    getUploadImage(data) {
      this.image = data;
    },
    confirm() {
      console.log(this.image);
      if (this.selectedUpload == 1) {
        this.insertImage();
      }
      if (this.selectedUpload == 2) {
        this.insertVideo();
      }
      if (!this.selectedUpload) {
        return;
      }
    },
    insertVideo() {
      const inHtml = `<div><p style="padding-bottom: 10px;"> </p><p><video controls  poster="${this.image}"  src="${this.video}" style="width: ${this.size.width}px;height: ${this.size.height}px;object-fit: fill"></video></p></div><p style="padding-bottom: 10px;"> </p>`;
      editorHandler.execCommand("insertHtml", inHtml);
      this.dialogVisible = false;
    },
    insertImage() {
      // console.log(editorHandler);
      // const inHtml = `<div><p style="padding-bottom: 10px;"> </p><p><image  src="${this.image}"  style="width: ${this.size.width}px;height: ${this.size.height}px;object-fit: fill"></video></p></div><p style="padding-bottom: 10px;"> </p>`;
      // editorHandler.execCommand("insertHtml", inHtml);
      // this.dialogVisible = false;
      const inHtml = `<div><p style="padding-bottom: 10px;"> </p><p><image  src="${this.image}"  style="width: ${this.size.width}px;height: ${this.size.height}px;object-fit: fill"></video></p></div><p style="padding-bottom: 10px;"> </p>`;
      editorHandler.execCommand("insertHtml", inHtml);
      this.dialogVisible = false;

      // if (this.image) {
      //   editorHandler.execCommand("insertImage", {
      //     src: this.image,
      //     width: this.size.width ? this.size.width : null,
      //     height: this.size.height ? this.size.height : null,
      //   });
      // }
      this.dialogVisible = false;
    },
    checkText() {
      if (!this.checked) {
        this.checked = true;
        textStopWord_Api({ text: this.content }).then((res) => {
          this.stop_words = res.data.stop_words;
          if (res.data.stop_words && this.stop_words.length != 0) {
            this.$global.error(
              this,
              `共查到${this.stop_words.length}个敏感词,请修改`,
              ""
            );
            this.stop_words.forEach((item) => {
              const Reg = new RegExp(item, "ig");
              if (this.content) {
                this.content = this.content.replace(
                  Reg,
                  `<i style="color: red;">${item}</i>`
                );
                //  console.log(res)
              }
            });
          } else {
            this.$global.success(this, `未查到敏感词,可以上传`, "");
            this.checked = false;
          }
        });
      } else {
        this.stop_words.forEach((item) => {
          console.log(item);
          const Reg = new RegExp(`<em style="color: red;">${item}<\/em>`, "ig");
          if (this.content) {
            this.content = this.content.replace(Reg, item);
            console.log(Reg);
            this.checked = false;
            this.$global.success(this, "已忽略敏感词");
          }
        });
      }

      //  console.log(this.content)
    },
    addCustomButtom(editorId) {
      this.addCustomButtom1(editorId);
      this.addCustomButtom2(editorId);
    },
    addCustomButtom2(editorId) {
      let that = this;
      window.UE.registerUI("btn", function(editor, uiName) {
        editorHandler = editor;
        var btn = new UE.ui.Button({
          name: "check",
          title: "检查",
          cssRules: `background-image: url('../../static/image/userManagement/API.png') !important;background-size: cover;`,
          onclick: function() {
            // that.dialogVisible = true;
            that.checkText();
            editor.execCommand(uiName);
          },
        });
        return btn;
      });
    },
    addCustomButtom1() {
      let that = this;
      window.UE.registerUI("dialog", function(editor, uiName) {
        editorHandler = editor;
        var btn2 = new UE.ui.Button({
          name: "file-upload",
          title: "上传图片",
          cssRules: `background-image: url('http://58.33.91.82:12404/wupen-test/images/news/upload.jpeg') !important;background-size: cover;`,
          onclick: function() {
            that.dialogVisible = true;
            editor.execCommand(uiName);
          },
        });
        return btn2;
      });
    },
  },
  watch: {
    value(newValue) {
      this.content = newValue;
    },
    content(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>
<style lang="scss" scoped>
.edui-editor {
  z-index: 3099 !important;
}
.image-upload-panel {
  overflow: hidden;
  text-align: center;
  width: 100%;
  .choose-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    p {
      width: 45%;
      text-align: center;
      cursor: pointer;
      border: 2px solid $timeBtn;
      border-style: dotted;
    }
    .selected {
      color: $lightenYellow;
    }
  }
  .video {
    margin-top: 20px;
    width: 300px;
  }
  .upload-video {
    margin-bottom: 20px;
  }
  .form-content-img {
    margin: 0 auto;
    margin-bottom: 40px;
    width: 220px;
  }
}

/deep/ .el-dialog__wrapper {
  z-index: 3000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/componentSet/Ueditor.vue